import { ROUTES } from '~/utils/routes';
import { useEditClientAdminUserFormHeader } from './hooks';
import { EditClientAdminUserFormHeaderPresentation } from './presentations';

type Props = {
  clientAdminUserId: number;
};

export const EditClientAdminUserFormHeader: React.FC<Props> = ({ clientAdminUserId }) => {
  const { fullName } = useEditClientAdminUserFormHeader({ clientAdminUserId });

  return (
    <EditClientAdminUserFormHeaderPresentation
      fullName={fullName}
      indexHref={ROUTES.ADMINS.INDEX}
    />
  );
};
